// ---------------------------------------------------------------------------
// Shared shell for the FORMAT / VERIFIED content tabs. Solid white
// background (no grid texture) + PepDirect logo lockup pinned bottom-right.
// Static content only, these panels are not carousels, so no arrows.
// ---------------------------------------------------------------------------
export default function TabShell({ children, testId }) {
  return (
    <div
      className="absolute inset-0 z-0 flex flex-col justify-center rounded-2xl bg-white"
      data-testid={testId}
    >
      {/* Content is vertically centered inside the parent's fixed height so
          shorter panels sit balanced rather than top-aligned with dead
          space below. Bottom padding reserves room for the logo lockup,
          slightly larger on mobile since the container's fixed 560px is
          tighter than the 584px desktop square. */}
      <div className="relative z-10 flex w-full flex-col px-6 pt-4 pb-12 sm:px-10 sm:pb-10">
        {children}
      </div>
      <img
        src="/logos/pepdirect-full.webp"
        alt="PepDirect · Authorized Distributor"
        className="pointer-events-none absolute bottom-4 right-5 z-10 h-4 opacity-70"
        draggable={false}
        data-testid={`${testId}-logo-lockup`}
      />
    </div>
  );
}
